module.exports = __webpack_public_path__ + "img/2_mfw_fr.932402de.jpg";